import { Component, AfterViewInit } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { ProductConcept } from '../../models';

@Component({
    selector: 'lib-concept-tree-list-view',
    templateUrl: './concept-tree-list-view.component.html',
    styleUrls: ['./concept-tree-list-view.component.css'],
    standalone: false
})
export class ConceptTreeListViewComponent extends ListItemRendererComponent<ProductConcept[]> implements AfterViewInit {
  constructor() {
    super();
  }

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }
}
